import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function UrgentErreurDeLivraison({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Les produits livrés par votre société (réf. 4013 E) ce jour ne sont pas
        conformes aux spécifications du contrat (réf. 4041 E). Nous ferons
        retour de ces produits et nous annulerons notre commande si je n'obtiens
        pas d'explications.
      </p>
      <p>
        Je me permets de vous rappeler que la société{" "}
        {variablesData.erreur_livraison_societe} a déjà dû subir par 3 fois de
        tels désagréments !
      </p>
      <p>
        En espérant recevoir au plus vite votre réponse, veuillez agréer,
        Monsieur, l'expression de mes sentiments respectueux.
      </p>
      <MailSignature
        emetteurLogo={UrgentErreurDeLivraison.metadata.emetteurLogo}
        emetteur={UrgentErreurDeLivraison.metadata.emetteur}
        emetteurPoste={UrgentErreurDeLivraison.metadata.emetteurPoste}
        emetteurEntreprise={UrgentErreurDeLivraison.metadata.emetteurEntreprise}
      />
    </div>
  );
}

UrgentErreurDeLivraison.metadata = {
  titre: "URGENT - erreur de livraison",
  cleMail: "urgent_erreur_de_livraison",
  messageTransfert: false,
  emetteur: "Jean BODIN",
  emetteurPoste: "Directeur Achat",
  emetteurEntreprise: "Société RELAX",
  emetteurLogo: null,
  dateRelative: -7,
  piecesJointes: [],
} as MailMetadata;

export default UrgentErreurDeLivraison;
